module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-list-select"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    staticClass: "patient-checkbox-all checkbox-large",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.selectAllCheckbox()
      }
    }
  })]), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('patient_name_furigana')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('patient_list_list.label.' + 'patient-name')) + " "), _c('i', {
    staticClass: "fa",
    class: _vm.getArrow('patient_name_furigana')
  })]), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('sex')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('patient_list_list.label.' + 'sex')) + " "), _c('i', {
    staticClass: "fa",
    class: _vm.getArrow('sex')
  })]), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('birthday')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('patient_list_list.label.' + 'birthday')) + " "), _c('i', {
    staticClass: "fa",
    class: _vm.getArrow('birthday')
  })]), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('age')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('patient_list_list.label.' + 'age')) + " "), _c('i', {
    staticClass: "fa",
    class: _vm.getArrow('age')
  })])])]), _c('tbody', _vm._l((_vm.orderedPatients), function(patient, index) {
    return _c('tr', [_c('td', [(patient.attributes['sel-flag'] === 1) ? _c('div', [_c('input', {
      staticClass: "patient-checkbox checkbox-large",
      attrs: {
        "type": "checkbox",
        "checked": "checked"
      },
      domProps: {
        "value": patient.id
      },
      on: {
        "click": function($event) {
          _vm.onChangeCheckbox($event.toElement)
        }
      }
    })]) : _c('div', [_c('input', {
      staticClass: "patient-checkbox checkbox-large",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": patient.id
      },
      on: {
        "click": function($event) {
          _vm.onChangeCheckbox($event.toElement)
        }
      }
    })])]), _c('td', [_vm._v(_vm._s(patient.attributes['patient-name']))]), _c('td', [_vm._v(_vm._s(patient.attributes['sex']))]), _c('td', [_vm._v(_vm._s(patient.attributes['birthday']))]), _c('td', [_vm._v(_vm._s(_vm.$t('age', {
      'age': patient.attributes['age']
    })))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f9aaa2a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/patient-list-select.pug
// module id = 360
// module chunks = 1